import React, { useEffect, useState } from 'react';
import { Input, Select } from 'antd';
import TextWinds from '../common/TextWinds';
import SimpleDialog from '../modal/SimpleDialog';
import DeliveryInfoList from './DeliveryInfoList';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import {
  getDeliveryInfoDefault,
  getDeliveryInfoList,
  selectDeliveryInfo,
} from '../../store/features/orderInfoSlice';
import DeliveryInfoCard from './DeliveryInfoCard';
import DeliveryInfoChange from './DeliveryInfoChange';

/**
 * 배송지 정보 컴포넌트
 * @param deliveryMessage 배송 메세지
 * @param onDeliveryMessageChange 배송 메세지 변경 핸들러
 */
const DeliveryInfo = ({
  deliveryMessage,
  onDeliveryMessageChange,
}: {
  deliveryMessage: string;
  onDeliveryMessageChange: (value: string) => void;
}) => {
  const dispatch = useAppDispatch();
  const deliveryInfo = useAppSelector(selectDeliveryInfo);

  const [state, setState] = useState<'none' | 'list' | 'form'>('none');
  const [isCustomMessage, setIsCustomMessage] = useState(false);
  const [message, setMessage] = useState(deliveryMessage);

  useEffect(() => {
    dispatch(getDeliveryInfoList({ url: '', params: {} }));
    dispatch(getDeliveryInfoDefault({ url: '', params: {} }));
  }, []);

  const openDialog = () => {
    setState('list');
  };
  return (
    <div className="mt-4 rounded-md bg-white px-[20px] py-[14px]">
      <TextWinds type="title_h4">배송지 정보</TextWinds>
      <div className="mt-4 text-sm">배송지 목록</div>
      {/* 선택된 배송지. 없다면 기본배송지 */}
      <DeliveryInfoCard
        deliveryInfo={deliveryInfo}
        onClick={openDialog}
        setState={setState}
      />

      <SimpleDialog
        open={state !== 'none'}
        title="배송지 정보"
        handleClose={() => setState('none')}
        onConfirm={() => setState('none')}
      >
        {state === 'form' ? (
          <DeliveryInfoChange setState={setState} />
        ) : (
          <DeliveryInfoList setState={setState} />
        )}
      </SimpleDialog>
      <div className="mt-4">
        <div className="text-sm">배송 메세지</div>
        <Select
          className="mt-4 w-full"
          size="large"
          placeholder="배송 메세지를 선택해주세요"
          value={isCustomMessage ? '직접 입력' : deliveryMessage || undefined}
          onChange={(value) => {
            if (value === '직접 입력') {
              setIsCustomMessage(true);
              setMessage('');
              onDeliveryMessageChange('');
            } else {
              setIsCustomMessage(false);
              onDeliveryMessageChange(value);
            }
          }}
          options={[
            {
              value: '안전하게 배송해주세요!',
              label: '안전하게 배송해주세요!',
            },
            {
              value: '부재 시 문 앞에 놓아주세요.',
              label: '부재 시 문 앞에 놓아주세요.',
            },
            {
              value: '부재 시 경비실에 맡겨주세요.',
              label: '부재 시 경비실에 맡겨주세요.',
            },
            {
              value: '배송 전 연락 부탁드립니다.',
              label: '배송 전 연락 부탁드립니다.',
            },
            { value: '직접 입력', label: '직접 입력' },
          ]}
        />
        {isCustomMessage && (
          <Input
            size="large"
            className="mt-2"
            placeholder="배송 메세지를 입력해주세요."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onBlur={() => onDeliveryMessageChange(message)}
          />
        )}
      </div>
    </div>
  );
};

export default DeliveryInfo;
